import { htmlToText } from './sanitize';

export const getDataDescription = ({ data, maxLength = 50 }: { data: any, maxLength: number }) => {
    if (!data) {
        return "No content";
    }

    let descriptionData: any = '';
    if (data.form) {
        const formFields = Object.keys(data.form).map(e => data.form[e]);

        let description = '';

        const textFormFields: any = formFields.filter(
            (item: any) => item.type === 'textarea' || item.type === 'text',
        );
        for (let i = 0; i < textFormFields.length; i++) {
            description += textFormFields[i].value;
            description += ' • ';
        }

        const otherFields: any = formFields.filter(
            (item: any) => item.type !== 'textarea' && item.type !== 'multiplechoice' && item.type !== 'multiple-choice-multi-select' && item.type !== 'text',
        );
        for (let i = 0; i < otherFields.length; i++) {
            if (otherFields[i].type === 'rating') {
                description += `${getEmojiForVal(
                    Math.round(otherFields[i].value * 10),
                )} Rating: ${formatCSATScore(otherFields[i].value)}`;
            } else {
                description += otherFields[i].value;
            }

            description += ' • ';
        }

        if (description !== '') {
            descriptionData = description.slice(0, -3);
        } else {
            descriptionData = description;
        }
    } else if (data.data && data.data.text) {
        descriptionData = data.data.text;
    }

    if (descriptionData === '') {
        return 'No content';
    }

    return truncate(descriptionData, maxLength);
};

export const truncate = (str: string, n: number) => {
    return str.length > n ? `${str.substr(0, n - 1)}...` : str;
};

export const getEmojiForVal = (val: number) => {
    if (val >= 100) {
        return '🤩';
    }
    if (val >= 75) {
        return '😊';
    }
    if (val >= 50) {
        return '😐';
    }
    if (val >= 25) {
        return '😢';
    }
    return '😡';
};

export const formatCSATScore = (val: number) => {
    const finalVal = Math.round(val * 10);
    return `${finalVal}%`;
};

// Message text for previews. Parsed inertly (see htmlToText): innerHTML on a
// detached div still loads `<img src=x onerror=…>` and runs the handler.
export const stripHtml = (html: any): string => htmlToText(html);
